import * as React from 'react'
import TextField from '../TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { Typography } from '@mui/material'
import { fetchIndustryCategories } from '../../../store/actions/businessListingActions'
import { useSelector, useDispatch } from 'react-redux'
import ListItemText from '@mui/material/ListItemText'

const IndustryDropDown = ({ handleValue, defaultValue, zIndex, borderLess, bgwhite }) => {
  const dispatch = useDispatch()
  const { industryCategories } = useSelector(state => state.businessReducer)
  // const filter = createFilterOptions()

  const fetchIndustry = val => {
    fetchIndustryCategories(dispatch, {
      search: val ? val : ' ',
    })
  }

  return (
    <Autocomplete
      size="small"
      ListboxProps={{
        sx: {
          padding: '8px',
          boxshadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
          borderRadius: '5px',
          // marginTop: '10px',
        }
      }}
      fullWidth
      value={defaultValue}
      onChange={(event, newValue) => {
        if (newValue && newValue.inputValue) {
          // Create a new value from the user input
          handleValue({ name: 'industry', value: newValue.inputValue })
        } else {
          handleValue({ name: 'industry', value: newValue ? newValue.replace('Add ', '') : newValue })
        }
      }}
      // filterOptions={(options, params) => {
      //   const filtered = filter(options, params)
      //   const { inputValue } = params
      //   // Suggest the creation of a new value
      //   const isExisting = options.some(option => inputValue === option)
      //   if (inputValue !== '' && !isExisting) {
      //     // filtered.push(`Add ${inputValue}`)
      //   }
      //   return filtered
      // }}
      onInputChange={e => e && fetchIndustry(e.target.value)}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      options={industryCategories}
      getOptionLabel={option => {
        if (typeof option === 'string') {
          return option.replace('Add ', '')
        }
        // Add "xxx" option created dynamically
        if (option.inputValue) {
          return option.inputValue.replace('Add ', '')
        }
        // Regular option
        return option.replace('Add ', '')
      }}
      renderOption={(props, option) => {
        return (
          <>
            <ListItemText key={option} {...props} style={{ border: 'none', borderRadius: '5px' }}>
              <Typography sx={{ fontSize: '14px', color: '#66668f' }}>{option}</Typography>
            </ListItemText>
          </>
        )
      }}
      renderInput={params => (
        <TextField
          {...params}
          label="Industry"
          bgwhite={bgwhite}
          borderLess={borderLess}
          InputLabelProps={{ shrink: false }}
        />
      )}
      noOptionsText={<Typography variant="h6" style={{ fontFamily: 'poppins', fontWeight: 'bold', fontSize: '12px' }}>{defaultValue ? defaultValue : 'Please select an industry from the drop-down menu options'}</Typography>}
      componentsProps={{
        popper: {
          className: `CustomAutoComplete ${zIndex ? 'showTopStack' : 'showDefaultStack'}`,
        },
      }}
    />
  )
}

export default IndustryDropDown
